import React, { useEffect } from 'react';
import { motion } from 'framer-motion';
import { CheckCircle, Mail } from 'lucide-react';
import { Card, CardContent } from '../components/ui/card';

const ThankYouPage = () => {
  useEffect(() => {
    // Fire Facebook Pixel Purchase event
    if (window.fbq) {
      window.fbq('track', 'Purchase', {
        value: 9.90,
        currency: 'USD'
      });
    }
  }, []);

  const handleEmailSupport = () => {
    window.location.href = 'mailto:pensamientos.cuanticos@gmail.com?subject=Soporte%20-%20El%20Poder%20de%20Manifestar';
  };

  return (
    <div className="thankyou-page">
      <div className="thankyou-background">
        <div className="thankyou-grid-overlay"></div>
      </div>

      <div className="thankyou-content">
        <motion.div
          initial={{ opacity: 0, scale: 0.9 }}
          animate={{ opacity: 1, scale: 1 }}
          transition={{ duration: 0.6 }}
          className="thankyou-card-wrapper"
        >
          <Card className="thankyou-card">
            <CardContent className="thankyou-card-content">
              <motion.div
                initial={{ scale: 0 }}
                animate={{ scale: 1 }}
                transition={{ delay: 0.3, type: "spring", stiffness: 200 }}
                className="thankyou-icon-wrapper"
              >
                <CheckCircle className="thankyou-icon" />
              </motion.div>

              <motion.h1
                initial={{ opacity: 0, y: 20 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ delay: 0.5 }}
                className="thankyou-title"
              >
                ¡Felicidades! 🎉
              </motion.h1>

              <motion.h2
                initial={{ opacity: 0, y: 20 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ delay: 0.6 }}
                className="thankyou-subtitle"
              >
                Tu Transformación Ha Comenzado
              </motion.h2>

              <motion.div
                initial={{ opacity: 0, y: 20 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ delay: 0.7 }}
                className="thankyou-message-box"
              >
                <Mail className="message-icon" />
                <div>
                  <h3 className="message-title">Revisa tu Bandeja de Entrada</h3>
                  <p className="message-text">
                    Hemos enviado tu acceso inmediato al Ebook "Mírate Viviendo la Vida que Deseas" 
                    junto con el Oráculo de 50 Prompts IA y el Entrenamiento de 21 Días.
                  </p>
                </div>
              </motion.div>

              <motion.div
                initial={{ opacity: 0, y: 20 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ delay: 0.8 }}
                className="thankyou-steps"
              >
                <h3 className="steps-title">Próximos Pasos:</h3>
                <div className="step-item">
                  <div className="step-number">1</div>
                  <p>Revisa tu correo electrónico (incluyendo spam)</p>
                </div>
                <div className="step-item">
                  <div className="step-number">2</div>
                  <p>Descarga tu Ebook y los bonos incluidos</p>
                </div>
                <div className="step-item">
                  <div className="step-number">3</div>
                  <p>Comienza tu práctica de 70 segundos hoy mismo</p>
                </div>
              </motion.div>

              <motion.div
                initial={{ opacity: 0, y: 20 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ delay: 0.9 }}
                className="thankyou-support"
              >
                <p className="support-text">¿Necesitas ayuda? Contáctanos:</p>
                <a 
                  href="mailto:pensamientos.cuanticos@gmail.com"
                  className="btn-support-email"
                >
                  <Mail className="btn-icon" />
                  pensamientos.cuanticos@gmail.com
                </a>
              </motion.div>

              <motion.div
                initial={{ opacity: 0 }}
                animate={{ opacity: 1 }}
                transition={{ delay: 1 }}
                className="thankyou-footer-note"
              >
                <p>
                  Gracias por confiar en <strong>El Poder de Manifestar</strong>. 
                  Estamos emocionados de ser parte de tu transformación.
                </p>
              </motion.div>
            </CardContent>
          </Card>
        </motion.div>

        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ delay: 1.2 }}
          className="thankyou-particles"
        >
          {[...Array(20)].map((_, i) => (
            <div
              key={i}
              className="particle"
              style={{
                left: `${Math.random() * 100}%`,
                animationDelay: `${Math.random() * 3}s`,
                animationDuration: `${3 + Math.random() * 2}s`
              }}
            />
          ))}
        </motion.div>
      </div>
    </div>
  );
};

export default ThankYouPage;
